import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import styles from '../HeroPanel.module.css';
import React, { FC } from 'react';
import { useHeroContext } from '../Hero';
import he from "he";

type TCustomPanelProps = {
    id: string | number,
    background?: string,
    Title: string,
    HeroSectionSuperscript: string,
    index: string,
};


export const CustomPanel: FC<TCustomPanelProps> = ({
    id,
    index,
    background,
    Title,
    HeroSectionSuperscript
}) => {

    const {
        type,
        activeIndex,
        handleSetActiveIndex } = useHeroContext();
    const isActive = activeIndex === id;

    return (
        <motion.div
            key={`hero-panel-${index}`}
            onClick={() => handleSetActiveIndex(0)}
            className={classNames(
                "heropanel-main",
                type,
                (index === activeIndex) && styles.open,
                styles.heropanel
            )}
            transition={{ type: "spring", damping: 20, bounce: 0 }}
            style={{
                background: `linear-gradient(35deg, ${background}, rgb(238, 233, 179))`,
            }}>
            <motion.div key={`mainPanel-${index}`} className={classNames(styles.mainPanel, 'textWrapper')} >
                {isActive &&
                <AnimatePresence key={`mainPanelContent-${index}`}>
                    <h1 className="title" dangerouslySetInnerHTML={{ __html: Title }}></h1>
                    <motion.h2 dangerouslySetInnerHTML={{ __html: HeroSectionSuperscript }} key={`motion-h2-mainPanel-${id}`} initial={{
                        opacity: 0
                    }} animate={{
                        opacity: 1, transition: {
                            delay: .2,
                            bounce: 0.1
                        }
                    }}></motion.h2>
                </AnimatePresence>
                }
                {!isActive && 
                <h1 className="title" style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    textAlign: 'center'
                }}>{he.decode(Title)}</h1>}
            </motion.div>
        </motion.div>
    )
}
